// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__ZVW6X","icon":"style_icon__2_DYn"};